import isomorphicCookie from "isomorphic-cookie"
import { trim } from "lodash/string"
import request from "../utils/fetch"
import { apiAuth } from "../api"
import { isomorphicVars } from "../scripts/isomorphicVars"
import { LOCAL_STORE_TOKEN } from "../constants"
import { getAccountSettings } from "../scripts/accountSettings"
import { getCookiesObject } from "../scripts/cookies"

const getCookie = () => {
  // Hack / Note setting this in renderOnServer
  // Use cookie set from request ( and stored in global ) when server side, otherwise default to cookie
  const cookie =
    typeof global[LOCAL_STORE_TOKEN] !== "undefined"
      ? global[LOCAL_STORE_TOKEN]
      : isomorphicCookie.load(LOCAL_STORE_TOKEN)
  // console.log('get cookie',cookie)
  return cookie
}

const auth = {
  authenticate({ username, password }) {
    const {
      authentic_account_id: accountId,
      public_url: publicUrl
    } = isomorphicVars()
    const accountSettings = getAccountSettings(accountId)
    const siteName = accountSettings.name
    const colours = accountSettings.settings.colours
    const logoUrl = accountSettings.favicon.url

    return request("/auth/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        username,
        password,
        brand: {
          name: siteName,
          body_background_color: "#FFFFFF",
          body_text_color: "#665544",
          header_background_color: colours.tertiary,
          header_text_color: "#000000",
          footer_background_color: colours.tertiary,
          footer_text_color: "#FFFFFF",
          button_background_color: colours.primary,
          button_text_color: "#FFFFFF",
          logo_url: logoUrl,
          homepage_url: publicUrl,
          unlock_url: `${window.location.origin}/unlock-account?unlock_token=`
        }
      })
    }).then(auth.saveToken)
  },

  checkRegistration(username) {
    const {
      auth_endpoint: authEndpoint,
      authentic_account_id: authenticAccountId
    } = isomorphicVars()

    return fetch(
      `${authEndpoint}/api/accounts/${authenticAccountId}/check_registration`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          email: username
        })
      }
    )
  },

  refreshToken() {
    const refresh_token = auth.getRefreshToken()
    if (!refresh_token) {
      return Promise.reject(new Error("No Refresh Token"))
    }

    const { public_url: publicUrl } = isomorphicVars()

    // this could be called on server, node-fetch needs the full url
    const url = trim(publicUrl, '"/')
    return request(`${url}/auth/refresh-token`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        refresh_token
      })
    }).then(auth.saveToken)
  },

  saveToken(token) {
    isomorphicCookie.save(LOCAL_STORE_TOKEN, JSON.stringify(token), {
      secure: false,
      httpOnly: false
    })

    return token.access_token
  },

  logout() {
    return auth.clearToken()
  },

  /**
   * Checks if a user is logged in
   */
  loggedIn() {
    // return !!get(LOCAL_STORE_TOKEN)
    return !!getCookie()
  },

  /**
   * Registers a user and then logs them in
   * @param  {string} username The username of the user
   * @param  {string} password The password of the user
   */
  register({ name, email, password }, authenticAccountId) {
    return apiAuth("POST", `/accounts/${authenticAccountId}/register`, {
      name,
      email,
      password
    }).then(userDetail => auth.authenticate({ username: email, password }))
  },

  resetPassword(email) {
    const environments = isomorphicVars()

    const accountSettings = getAccountSettings(
      environments.authentic_account_id
    )

    const colours = environments.accountSettings.settings.colours
    const logo = accountSettings.favicon.url

    return request("/auth/password", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        email,
        brand: {
          name: accountSettings.name,
          reply_to: "support@stqry.com",
          header_text_color: colours.light,
          header_background_color: colours.light,
          body_text_color: colours.dark,
          body_background_color: colours.light,
          button_text_color: colours.light,
          button_background_color: colours.success,
          footer_text_color: colours.light,
          footer_background_color: colours.secondary,
          logo_url: logo,
          homepage_url: environments.public_url,
          edit_password_url: `${
            window.location.origin
          }/change-password?reset_password_token=`
        }
      })
    })
  },

  getToken() {
    const token = getCookie()
    return token
  },

  getAccessToken() {
    const token = auth.getToken()
    return token ? token.access_token : null
  },

  getRefreshToken() {
    const token = auth.getToken()
    return token ? token.refresh_token : null
  },

  clearToken() {
    const cookie = getCookiesObject()

    if (typeof global[LOCAL_STORE_TOKEN] !== "undefined") {
      delete global[LOCAL_STORE_TOKEN]
    }

    // TODO: isomorphicCookie.remove doesn't work correctly. Should be replaced in the next major release
    isomorphicCookie.remove(LOCAL_STORE_TOKEN)
    return cookie.set(LOCAL_STORE_TOKEN, null)
  }
}

export default auth



// WEBPACK FOOTER //
// ./webapp/auth/index.js